module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "map"
    }
  }), _c('strong', [_vm._v("MAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_12_map1#map1"
    }
  }, [_vm._v("1. Negro Population by Wards, Chicago, 1900")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_12_map1#map2"
    }
  }, [_vm._v("2. Negro Population by Wards, Chicago, 1910")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_12_map1#map3"
    }
  }, [_vm._v("3. Negro Population by Census Tracts, Chicago, 1910")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_12_map1#map4"
    }
  }, [_vm._v("4. Negro Population by Census Tracts, Chicago, 1920")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c84fd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226160702_07_map.vue
// module id = 75
// module chunks = 0